<template>
	<div v-if="order" id="printTimeslotItems" class="printTimeslotItems flex flex-col">
		<div class="flex flex-col gap-3">
			<span>{{ now }}</span>
			<div v-for="(value, key) in order" :key="key">
				<div>{{ key }}</div>
				<div v-for="v in value" :key="v" class="pl-5">- {{ v }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';

	export default {
		name: 'PrintTimeslotItemsModal',
		data: () => ({
			order: {},
		}),
		computed: {
			now() {
				return moment()
					.parseZone()
					.format('MMM DD, YYYY HH:mm:ss');
			},
		},
		methods: {
			print() {
				// Get HTML to print from element
				const prtHtml = document.getElementById('printTimeslotItems').innerHTML;

				// Get all stylesheets HTML
				let stylesHtml = '';
				for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
					stylesHtml += node.outerHTML;
				}

				// Open the print window
				const WinPrint = window.open(
					this.order,
					'',
					'left=0,top=0,width=700,height=600,toolbar=0,scrollbars=0,status=0'
				);

				WinPrint.document.write(`<!DOCTYPE html>
          <html lang="en">
            <head>
            <title>Print Order</title>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

				window.setTimeout(() => {
					WinPrint.document.close();
					WinPrint.focus();
					WinPrint.print();
					WinPrint.close();
				}, 50);
			},
		},
		mounted() {
			this.emitter.on('printTimeslotItems', (order) => {
				this.order = order;
				this.$nextTick(() => {
					this.print();
				});
			});
		},
		beforeUnmount() {
			this.emitter.off('printTimeslotItems', null);
		},
	};
</script>

<style lang="scss" scoped>
	.divider {
		@apply my-2;
		border-bottom: 1px dashed black;
	}

	.printTimeslotItems {
		display: none;
	}

	@page {
		size: auto;
	}

	@media print {
		footer {
			display: none;
		}

		header {
			display: none;
		}
	}

	@media print {
		@page {
			margin-top: 20px;
			margin-bottom: 20px;
		}
		body {
			padding-top: 72px;
			padding-bottom: 72px;
		}
		.divider {
			@apply my-2;
			border-bottom: 1px dashed black;
		}

		.printTimeslotItems {
			display: none;
		}
	}
</style>
